module.exports = __webpack_public_path__ + "76965c96008e0cb96e0b9996c3d5810b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/bangkok.png
// module id = 1370
// module chunks = 47